import React, { useEffect } from 'react';
import { Loader } from '@inplayer-org/inplayer-ui';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

// actions
import { fetchSubscriptionsByStatus, fetchSubscriptionsStatus } from 'ducks/merchantDucks/subscriptions/actions';

// types
import RootState from 'ducks/RootState';

// components
import EmptyMessage from 'components/EmptyMessage';
import Tile from './Tile';
import DonutPieChart from './charts/DonutPieChart';
import { SubscriptionStatusType, GroupByType } from './ActiveSubscriptions';

enum ChartSubscriptions {
  ACTIVE = 'total_active',
  TRIALING = 'total_trialing',
}

const ActiveSubscribersChart = () => {
  const dispatch = useDispatch();
  const { startDate, endDate } = useSelector((state: RootState) => state.datepicker);
  const subscriptionStatuses = useSelector(
    (state: RootState) => state.subscriptions.totalSubscriptionsStatuses.statuses
  );
  const statusesFetching = useSelector((state: RootState) => state.subscriptions.totalSubscriptionsStatuses.isFetching);

  const activeFreeTrialSubs =
    (!isEmpty(subscriptionStatuses) &&
      Object.keys(subscriptionStatuses)
        .filter(
          (subscriptionType) =>
            subscriptionType === ChartSubscriptions.ACTIVE || subscriptionType === ChartSubscriptions.TRIALING
        )
        .map((subscriptionType) => {
          return { name: subscriptionType, value: subscriptionStatuses[subscriptionType] };
        })
        .filter((subscription) => subscription.value > 0)) ||
    [];

  useEffect(() => {
    dispatch(fetchSubscriptionsByStatus(SubscriptionStatusType.ACTIVE, GroupByType.ITEM));
    dispatch(fetchSubscriptionsByStatus(SubscriptionStatusType.ACTIVE, GroupByType.PRICE));
    if (isEmpty(subscriptionStatuses)) {
      dispatch(fetchSubscriptionsStatus(startDate, endDate));
    }
  }, []);

  return (
    <>
      <Tile
        title="Active subscriptions"
        tileWidth="100%"
        tileContent={
          // eslint-disable-next-line no-nested-ternary
          activeFreeTrialSubs.length > 0 ? (
            <DonutPieChart data={activeFreeTrialSubs} name="name" value="value" />
          ) : statusesFetching ? (
            <Loader />
          ) : (
            <EmptyMessage variant="p">There is no available data for this time period.</EmptyMessage>
          )
        }
      />
    </>
  );
};

export default ActiveSubscribersChart;
